import React from "react";
import styled from "styled-components";
import { PrimaryMedium } from "@ui/components/containers/primary";

export const EmptyChannel: React.FC = () => {
	return (
		<Container>
			<PrimaryMedium>vous n'avez pas de discussion </PrimaryMedium>
		</Container>
	);
};

const Container = styled.div`
	padding: 20px;
	padding-top: 0;

	> div {
		color: ${({ theme }) => theme.colors.textSecondary};
	}
`;
